import { ReactElement } from 'react';
import { Column, Row, Modal } from 'carbon-components-react';
import { getMessage } from '../hooks/widgets/useLang';
import { FormattedMessage } from 'react-intl';
import '../style/common.scss';
import '../style/responseModal.scss';

export interface modalMessageProperties {
  setShowResponseModal: React.Dispatch<React.SetStateAction<boolean>>;
  showResponseModal: boolean;
  textResponse: string;
  messages: any;
}

export const ModalMessage = ({
  showResponseModal: showModal,
  setShowResponseModal: setShowModal,
  textResponse,
  messages,
}: modalMessageProperties): ReactElement => {
  const render = (
    <div className="ResponseModal">
      <Row>
        <Column sm={4} md={16} lg={16}>
          <Modal
            open={showModal}
            modalHeading={`${getMessage(messages.modalResponseText)}`}
            primaryButtonText={<FormattedMessage {...messages.modalContinue} />}
            onRequestClose={() => {
              setShowModal(false);
            }}
            onRequestSubmit={() => {
              setShowModal(false);
            }}
          >
            <p className="mar5">
              <span className="slide_text">{textResponse}</span>
              <br />
            </p>
            <br />
          </Modal>
        </Column>
      </Row>
    </div>
  );
  return render;
};
